var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1588 4.513C18.6528 0.0340773 11.347 0.0340773 6.84096 4.513C2.33491 8.99339 2.33491 16.2562 6.84096 20.7351L14.9992 28.8461L23.1588 20.7351C27.6649 16.2562 27.6649 8.99339 23.1588 4.513ZM14.9992 16.4573C14.0356 16.4573 13.1313 16.0783 12.449 15.3904C11.0427 13.9693 11.0427 11.6577 12.449 10.2366C13.1298 9.5487 14.0356 9.16974 14.9992 9.16974C15.9627 9.16974 16.8685 9.5487 17.5493 10.2366C18.9557 11.6577 18.9557 13.9708 17.5493 15.3904C16.8685 16.0783 15.9627 16.4573 14.9992 16.4573Z",
    fill: "#FF9D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocation);
export default __webpack_public_path__ + "static/media/ic_location.4dd9671b2f835f979102f2326ecf18b0.svg";
export { ForwardRef as ReactComponent };